enum ENV {
  local = "local",
  oa = "oa",
  pre = "pre",
  pro = "pro",
}

declare global {
  interface Window {
    ENV_TYPE: ENV;
  }
}

const env = process.env.ENV_TYPE as ENV;
export const isDev = process.env.NODE_ENV === "development";

const ENV_MAP = {
  local: "oa",
  dev: "oa",
  oa: "oa",
  pre: "",
  pro: "",
};

const MOCK_URL = "https://yapi.yuewen.com/mock/2309";
const envPrefix = env === "pro" || env === "local" ? "" : env;
const coverEnvPrefix = ENV_MAP[env];

/**
 * 获取接口需要在 Header 中添加的相应 host
 * @param url
 * @returns {string}
 */
export const composeServerHost = (url: string) => {
  if (isDev) {
    if (env === "local") {
      return "";
    }
    return `${envPrefix}www.chereads.com`;
  }
  // 非本地环境
  // /go 接口
  if (/^\/go/.test(url)) {
    return process.env.GO_SERVER_HOST; // define on pm2 config
  }
  return undefined;
};

/**
 * 拼接 服务端直出接口的完整路径
 * @param url
 * @returns {string}
 */
export const composeServerCgi = (url: string) => {
  if (isDev) {
    if (env === "local") {
      return `${MOCK_URL}${url}`;
    }
    return `http://localhost:3080${url}`;
  }
  // /go 接口
  if (/^\/go/.test(url)) {
    return `http://${process.env.GO_ROOT}${url.replace("/go/pcm", "")}`; // define on pm2 config
  }
  return `https://${envPrefix}www.chereads.com${url}`; // 默认走域名，再过一次 nginx 转发
};

export const imagePath = () => {
  if (env === "pro" || env === "pre") {
    return "https://webbanner.webnovel.com";
  }
  return "https://webbannertest.webnovel.com";
};

export default {
  envType: env,
  protocol: "https://",
  activity: `https://${ENV_MAP[env]}activity.webnovel.com`,
  statics: `${envPrefix}www.yueimg.com`,
  cover: `https://${
    env === "pre" || env === "pro" ? "" : "oa-"
  }book-pic.webnovel.com`,
  banner: `${coverEnvPrefix}banner.webnovel.com`,
  badge: `${envPrefix}actimg.webnovel.com`,
  avatar: `${
    coverEnvPrefix ? coverEnvPrefix + "-" : coverEnvPrefix
  }user-pic.webnovel.com`,
  userBackground: `${
    coverEnvPrefix ? coverEnvPrefix + "-" : coverEnvPrefix
  }user-pic.webnovel.com`,
  publicPath: isDev ? "/" : `https://${envPrefix}www.yueimg.com/overseamnext/`, // 静态资源地址
};
